<!-- Тексты и данные перехода ремонта для API -->
<template>
  <RecordListStatusTransitionForm
    :key="status"
    form-id="fleet-repair-transition"
    :with-occurred-at="isCompletion"
    date-label="Когда фактически выполнили"
    :comment-label="isCompletion ? 'Что сделали' : 'Причина'"
    :comment-placeholder="isCompletion ? 'Опишите выполненные работы и результат' : 'Коротко поясните изменение статуса'"
    :is-submitting="isSubmitting"
    @submit="submit"
  >
    <BaseFormField v-if="isCompletion && repair" label="Связанные пометки" wide>
      <FleetRepairRemarkSelect v-model="relatedIds" resource="remarks" :vehicle-id="repair.vehicle_id"
        :initial-records="repair.remarks || []" :disabled="isSubmitting" />
    </BaseFormField>
  </RecordListStatusTransitionForm>
</template>
<script>
import FleetRepairRemarkSelect from "@/components/Fleet/RepairRemark/Select.vue";
import { mapAssociationList } from "@/utils/associationListUtils";
import RecordListStatusTransitionForm from "@/components/RecordList/StatusTransition/Form.vue";

export default {
  name: "FleetRepairStatusForm",
  components: { RecordListStatusTransitionForm, FleetRepairRemarkSelect },
  props: {
    repair: { type: Object, default: null },
    status: { type: String, required: true },
    isSubmitting: { type: Boolean, default: false },
  },
  emits: ["submit"],
  data() { return { relatedIds: mapAssociationList(this.repair?.remarks, (record) => record.id) }; },
  computed: {
    isCompletion() { return this.status === "done"; },
  },
  methods: {
    submit({ comment, occurred_at }) {
      this.$emit("submit", {
        ...(this.isCompletion && this.repair ? { remark_ids: this.relatedIds } : {}),
        status: this.status,
        comment,
        completed_at: occurred_at,
      });
    },
  },
};
</script>
